<template>
  <div class="class-list-root">
    <div class="header-bar">班级列表</div>
    <div class="class-list-content">
      <div
        v-for="item in classList"
        :key="item.id"
        class="class-card"
        @click="goClassDetail(item)"
      >
        <div class="class-card-main">
          <div class="class-card-title-row">
            <span class="class-type">{{ item.type }}</span>
            <span class="class-year">{{ item.year }}届</span>
          </div>
          <div class="class-location">{{ item.school }} {{ item.room }}</div>
        </div>
        <div class="class-card-right">
          <span class="class-student-count">
            <i class="icon-student" />{{ item.studentCount }} 学生
          </span>
          <span class="class-card-arrow">
            <svg width="18" height="18" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" stroke="#B0B3B8" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const classList = ref([
  {
    id: 1,
    type: '理科班',
    year: '2025',
    school: '成都武侯分校',
    room: '116室',
    studentCount: 7,
  },
  {
    id: 2,
    type: '文科班',
    year: '2025',
    school: '成都武侯分校',
    room: '116室',
    studentCount: 4,
  },
])

const goClassDetail = (item) => {
  router.push({
    path: '/classDetail',
    query: { classId: item.id },
  })
}
</script>

<style lang="scss" scoped>
.class-list-root {
  min-height: 100vh;
  background: linear-gradient(180deg, #f7faff 0%, #f2f3f7 100%);
  padding-bottom: 32px;
}
.header-bar {
  font-size: 22px;
  font-weight: 700;
  color: #222;
  padding: 22px 0 18px 20px;
  background: transparent;
  letter-spacing: 1px;
}
.class-list-content {
  padding: 0 12px;
}
.class-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px 0 rgba(36,102,246,0.06), 0 1.5px 4px 0 rgba(0,0,0,0.03);
  margin-bottom: 18px;
  padding: 18px 18px 14px 20px;
  transition: box-shadow 0.18s, transform 0.18s;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  &:active {
    box-shadow: 0 8px 32px 0 rgba(36,102,246,0.13);
    transform: scale(0.98);
  }
}
.class-card-main {
  flex: 1;
  min-width: 0;
}
.class-card-title-row {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 7px;
}
.class-type {
  font-size: 18px;
  font-weight: 700;
  color: #2466f6;
  letter-spacing: 0.5px;
}
.class-year {
  font-size: 15px;
  color: #7a8599;
  font-weight: 500;
  margin-left: 2px;
}
.class-location {
  color: #7a8599;
  font-size: 14px;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.class-card-right {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 18px;
}
.class-student-count {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #2466f6;
  font-weight: 600;
  font-size: 14px;
}
.icon-student {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url('data:image/svg+xml;utf8,<svg fill="%232466f6" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-3.3137 3.134-6 7-6s7 2.6863 7 6"/></svg>') no-repeat center/contain;
  margin-right: 2px;
}
.class-card-arrow {
  display: flex;
  align-items: center;
}
@media (max-width: 600px) {
  .header-bar {
    font-size: 19px;
    padding: 16px 0 12px 14px;
  }
  .class-card {
    padding: 14px 10px 10px 12px;
    border-radius: 14px;
  }
  .class-card-title-row {
    font-size: 16px;
  }
}
</style> 